class StickyMobileAtc extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-sg-sticky-atc-trigger]');
    this.observeTarget =
      document.querySelector('.js-product-buttons') ||
      document.querySelector('.product-form__add') ||
      document.querySelector('product-form');

    if (!this.trigger) return;

    this.trigger.addEventListener('click', () => {
      const addButton =
        document.querySelector('.js-product-add') ||
        document.querySelector('product-form [name="add"]');
      if (addButton && !addButton.disabled) {
        addButton.click();
      }
    });

    if (!this.observeTarget || typeof IntersectionObserver === 'undefined') {
      this.classList.add('is-visible');
      document.body.classList.add('sg-sticky-atc-pad');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const show = Boolean(entry && !entry.isIntersecting);
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('sg-sticky-atc-pad', show);
      },
      { threshold: 0, rootMargin: '0px' }
    );

    this.observer.observe(this.observeTarget);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    document.body.classList.remove('sg-sticky-atc-pad');
  }
}

customElements.define('sticky-mobile-atc', StickyMobileAtc);
